import ManageMySpending from "../ManageMySpending";
import { Button1, Checkbox, Select } from "../../index";
import Table from "../../table/Table";
import { useEffect, useState } from "react";
import { billsApi } from "../../../api/endpoints";
import { useAccounts } from "../../../data/live";
import { useAuth } from "../../../api/useAuth";
import { useNavigate } from "react-router-dom";
import { message } from "antd";

const last4 = (s) => (s ? String(s).slice(-4) : "0000");

const AddBillers = () => {
  const navigate = useNavigate();
  const { accounts } = useAccounts();
  const { user } = useAuth();

  const [billers, setBillers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState({});
  const [sourceAccountId, setSourceAccountId] = useState("");

  const userName = user
    ? `${user.firstName || ""} ${user.lastName || ""}`.trim() || user.email
    : "Account";

  const accountOptions = accounts.map((a) => ({
    name: `${a.currency} • ****${last4(a.accountNumber || a.iban)}${
      a.isDefault ? " (Default)" : ""
    }`,
    value: a.id,
  }));

  useEffect(() => {
    if (accounts.length > 0 && !sourceAccountId) {
      setSourceAccountId(accounts[0].id);
    }
  }, [accounts, sourceAccountId]);

  useEffect(() => {
    setLoading(true);
    billsApi
      .listBillers()
      .then((data) => setBillers(Array.isArray(data) ? data : []))
      .catch(() => setBillers([]))
      .finally(() => setLoading(false));
  }, []);

  const toggle = (id) => {
    setSelected((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const selectedIds = Object.keys(selected).filter((k) => selected[k]);

  const handleAdd = async () => {
    if (selectedIds.length === 0) {
      message.warning("Select at least one biller");
      return;
    }
    message.success(
      `${selectedIds.length} biller(s) added, go to My Bills to schedule`
    );
    navigate("/billers");
  };

  const addBillerTableHeader = [
    <Checkbox key="cb" />,
    "Biller Name",
    "Category",
    "Frequency",
    "Next Due Date",
    "Amount",
    "Payment Method",
  ];

  const addBillerTableBody = billers.map((b) => ({
    checkbox: (
      <Checkbox
        checked={!!selected[b.id]}
        onChange={() => toggle(b.id)}
      />
    ),
    billerName: b.name || "-",
    category: b.category || "Other",
    tags: b.tags || ["Tag1"],
    frequency: b.frequency || "Once",
    nextDueDate: b.nextDueDate
      ? new Date(b.nextDueDate).toLocaleDateString()
      : "-",
    amount: `${b.currency || "AUD"} ${Number(b.amount || 0).toLocaleString()}`,
    paymentMethod: b.paymentMethod || "Manual Payment",
  }));

  return (
    <>
      <ManageMySpending navName={"Manage My Spending"}>
        <div className="d-flex flex-column gap-3 mt-3">
          <div>
            <Select
              value={sourceAccountId}
              onChange={(e) => setSourceAccountId(e.target.value)}
              options={accountOptions}
              defaultValue="Select account"
              className="bg-light rounded-5 w-auto"
              popupClassName="bg-White"
            />
          </div>

          <div className="d-flex justify-content-between align-items-center">
            <span className="fs-5 fw-semibold">My Bills</span>
          </div>

          <div className="d-flex flex-column gap-3 border rounded-3">
            <div className="d-flex justify-content-md-between justify-content-center p-3 border-bottom align-items-center flex-wrap flex-md-nowrap">
              <span className="fs-5 fw-semibold">Add Billers</span>
              <div className="d-flex gap-md-2 align-items-center gap-3  flex-wrap flex-md-nowrap justify-content-center justify-content-md-start">
                <span className="fs14px ">
                  Select the transaction we have found or
                </span>
                <Button1
                  buttonName={"Add Manual Biller"}
                  className={"btn-dark"}
                />
              </div>
            </div>

            <div className="px-4 p-3">
              {loading ? (
                <div className="text-center p-3">Loading billers...</div>
              ) : billers.length === 0 ? (
                <div className="text-center p-4 text-muted">
                  No billers available yet.
                </div>
              ) : (
                <Table
                  AddBillersTable={true}
                  tableHeaders={addBillerTableHeader}
                  tableBody={addBillerTableBody}
                />
              )}
            </div>

            <div className="d-flex justify-content-md-end align-items-center gap-2 p-3 px-5 justify-content-between">
              <Button1
                buttonName={"Cancel"}
                className={"btn-outline-danger"}
                onClick={() => navigate(-1)}
              />
              <Button1
                buttonName={`Add Billers${
                  selectedIds.length ? ` (${selectedIds.length})` : ""
                }`}
                className={"btn-dark"}
                onClick={handleAdd}
              />
            </div>
          </div>
        </div>
      </ManageMySpending>
    </>
  );
};

export default AddBillers;
